import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("Rastreo");

export const Rastreo = cacheResource({
    /**Obtiene el rastreo de una guia dado su folio */
    RastrearGuia: async (folioGuia: string): Promise<models.GuiaRastreoDTO> => await controller('RastrearGuia', { folioGuia }),

    ObtenerInformacionCliente: async (folioGuia: string): Promise<models.InformacionCliente | null> => await controller('ObtenerInformacionCliente', { folioGuia }),

}, {
    }, {
    });




// WEBPACK FOOTER //
// ./app/resources/items/rastreo.tsx